import React, {useContext, useEffect, useRef, useState} from "react";
import {MainContextProvider} from "../../../context/MainContext";
import icon from "../../../assets/images/stepsIcons/wait-white.svg"
import clientIcon from '../../../assets/images/client.png'
import customAxios from "../../../service/api/interceptors";
import {useHistory, useParams} from "react-router-dom";
import {ProjectSuggestionsType} from "../ProjectSuggestions.type";
import {toastifyError} from "../../../service/toastify/toastify";
import moment from "moment";
import taskEditIcon from "../../Client/Offer/ccomponents/TaskDeliverablesForOffer/taskEditIcon.svg";
import {useOnClickOutside} from "../../../hooks/useOnClickOutside";
import {deleteSingleTask} from "../../../service/tasks";
import {intercomCatchErrorMessage} from "../../../helpers/intercomCatchErrorMessage";
import ModalContainer from "../../../components/ModalContainer";
import {Input} from "../../../components/UI";
import {CreateLegalTask} from "../../Modals/CreateLegalTask/CreateLegalTask";
import {CustomLoader} from "../../../components/UI/CustomLoader/CustomLoader";
import {CreateRequestFromBG} from "../modals/CreateRequestFromBG";

const statuses = [
    { value: '5', label: 'Awaiting client approval', color: '#000000' },
    { value: '2', label: 'To do', color: '#2361FF' },
    { value: '1', label: 'In progress', color: '#000000' },
    { value: '3', label: 'Done', color: '#07B56C' },
]

export const SuggestionView: React.FC = () => {
    const { setLoading: setSystemLoader, userData, setModalData, setModalType, modalType } = useContext(MainContextProvider)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const history = useHistory();
    const { id, suggestionId }: { id: string, suggestionId: string } = useParams()
    const [tasks, setTasks] = useState<any[]>([])
    const [suggestion, setSuggestion] = useState<ProjectSuggestionsType>({} as ProjectSuggestionsType)
    const [cost, setCost] = useState<number>(0)
    const [creditCost, setCreditCost] = useState<number>(0)
    const [requestProjectSuggestions, setRequestProjectSuggestions] = useState<ProjectSuggestionsType | null>(null)
    const [isUnconfirmedTasks, setIsUnconfirmedTasks] = useState(false)

    const getData = async () => {
        setLoading(true)
        try {
            const { status, data: el } = await customAxios.get(`/project-suggestion/${suggestionId}`)
            if (status === 200) {
                setIsModalOpen(false)

                setIsUnconfirmedTasks(el?.is_unconfirmed_tasks === 1)
                setSuggestion(el)
                setTasks(el.tasks?.tasks)
                setCost(el.tasks?.total)
                setCreditCost(el.tasks?.credit_total)
            }
        } catch (e) {}
        setLoading(false)
    }

    useEffect(() => {
        setSystemLoader(false);
        document.title = "Suggestion view";
        getData()
    }, [])

    const deleteTask = async (id: number) => {
        setLoading(true)
        try {
            const { status } = await deleteSingleTask(id)
            if(status === 204) {
                await getData()
            }
        } catch (e) {}
        setLoading(false)
    }

    const getTime = (price_per_hour: string, accepted: string, deadline: string, time_estimate: string) => {
        if(price_per_hour) {
            return '-'
        }

        return `${time_estimate} days`
    }

    useEffect(() => {
        if (modalType === "update-suggestion-task"){
            getData()
            setModalType('')
        }
    }, [modalType])

    const getStatusItem = (status: number) => {
        return statuses.find((el) => el.value + '' === status + '')
    }

    const setTaskUsConfirmed = async () => {
        setLoading(true)
        try {
            const { status } = await customAxios.post(`/project-suggestion/${suggestionId}/client-confirmed`)
            if (status === 200) {
                await getData()
            }
        } catch (e) {}
        setLoading(false)
    }

    if (loading) {
        return <CustomLoader />
    }

    return (
        <div className={"singleOffer task-view"}>
            <div className="task-view__left-side">
                <div className="task-body">
                    <div className="offerHeader" style={{ background: "#A3A9B9", margin: "-20px -30px 0px", padding: "12px 20px", borderRadius: "10px 10px 0 0" }}>
                        <div className="offerHeader__left">
                            <div className="offerHeader__status" style={{ color: "#fff", display: "flex", alignItems: "center" }}>
                                <img style={{ marginRight: "9px" }} src={icon} alt=""/>
                                Suggestion
                            </div>
                        </div>
                    </div>
                    <div className="offerHeading">
                        <div className="offerHeader__date">
                            <b>UPDATED ON: </b>
                            <span>{moment(suggestion.updated_at * 1000).format("DD/MM/YYYY")}</span>
                        </div>
                        <h2 className="offerHeading__heading">
                            {suggestion.title}
                        </h2>
                        <div className="offerHeading__text task-body__description task-body__description-block">
                            <p dangerouslySetInnerHTML={{ __html: suggestion.description }} />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ width: "480px", flexShrink: 0 }}>
                <div className="task-deliverables-for-offer">
                    <div className="task-tab-list">
                        <div className="tabs__header">
                            <div className="tabs__header-item tabs__header-item-active">Suggested Steps</div>
                        </div>
                        {userData?.status.type_code === 300 && <div onClick={() => {
                            setIsModalOpen(true)
                        }} className="task-tab-list__button mt15">
                            <div className="task-tab-list__circle">
                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <rect x="3.73291" width="1" height="8" fill="white"/>
                                    <rect y="4.6" width="1" height="8" transform="rotate(-90 0 4.26669)" fill="white"/>
                                </svg>
                            </div>
                            <b>ADD STEPS</b>
                        </div>}
                        <div className="task-tab-list__table mt10">
                            <div>
                                {tasks.length > 0 && <div style={{color: "#8a93ad", fontSize: "13px", fontWeight: 400}}>LEGAL NODES
                                    TASKS</div>}
                                {
                                    tasks.length > 0 && tasks.map(task => (
                                        <TaskItem
                                            key={task.id}
                                            userData={userData}
                                            task={task}
                                            setModalType={setModalType}
                                            setModalData={setModalData}
                                            deleteTask={deleteTask}
                                            getStatusItem={getStatusItem}
                                            getTime={getTime}
                                        />
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    <div className="offer-footer">
                        <div className="offer-footer__left" />
                        <div className="offer-footer__right">
                            <div className="offer-footer__price" style={{ textAlign: 'right' }}>
                                {cost > 0 && <><span>Total price <b>${cost}</b></span><br /></>}
                                {creditCost > 0 && <span style={{display: "block"}}
                                       className={"mt5"}>LN Credits <b>{creditCost}</b></span>}
                            </div>
                        </div>
                    </div>

                    {!suggestion.offer?.id && <button onClick={() => setRequestProjectSuggestions(suggestion)} className="btn-black text-uppercase w100 mt15">Get started</button>}
                    {isUnconfirmedTasks && <button onClick={setTaskUsConfirmed} className={"btn-white w100 mt15"}>MARK ALL STEPS AS "CLIENT INTENT CONFIRMED"</button>}
                </div>
            </div>
            <LocalTaskModal
                isOpen={isModalOpen}
                save={() => setIsModalOpen(false)}
                close={() => {setIsModalOpen(false); getData()}}
                project_suggestion_id={+suggestionId}
                updateItem={getData}
            />
            <CreateRequestFromBG
                isOpen={!!requestProjectSuggestions}
                close={() => setRequestProjectSuggestions(null)}
                project_suggestion={requestProjectSuggestions}
                company_id={userData?.companies[0]?.id}
            />
        </div>
    )
}

const LocalTaskModal: React.FC<{ isOpen: boolean, close: () => void, save: () => void, project_suggestion_id: number, updateItem: () => void }> = ({ isOpen, save, close, project_suggestion_id, updateItem }) => {
    return (
        <div className={"follow-up-modal"} >
            <ModalContainer isOpen={isOpen} close={close}>
                <CreateLegalTask extraProps={{ project_suggestion_id }} updateItem={updateItem} />
            </ModalContainer>
        </div>
    )
}

const TaskItem: React.FC<any> = ({ userData, task, setModalType, setModalData, deleteTask, getStatusItem, getTime }) => {
    const [isOpen, setIsOpen] = useState(false)
    const dropdownRef = useRef<HTMLDivElement>(null)
    useOnClickOutside({ ref: dropdownRef, handler: () => setIsOpen(false) })

    return (
        <div id={`offer-task-id-${task.id}`} className={'singleOffer__deliverables-task w100'} style={{ border: '1px solid rgb(202, 213, 221)', position: 'relative' }}>
            <div className="singleOffer__deliverables-task-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', }}>
                <p>{task.title}</p>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {!!Number(task.is_fee_exempt) && userData?.status.type_code === 300 && <div className={'singleOffer__deliverables-task-title-fee_exempt'}>
                        Fee Exempt
                    </div>}
                    {userData?.status.type_code === 300 && <div ref={dropdownRef} className={'task-deliverables-for-offer__dropdown'}>
                        <img onClick={() => setIsOpen(!isOpen)} src={taskEditIcon} alt=""/>
                        {isOpen && <div className="offerHeader__dropdown-container task-status__body">
                            <div onClick={() => {
                                setModalType('create_legal_task')
                                setModalData({id: task.id, project_id: task.project_id, partner_request_id: task.partner_request_id})
                            }} className={'task-status__body-item'}>Edit
                            </div>
                            <div style={{color: 'red'}} onClick={() => deleteTask(task.id)}
                                 className={'task-status__body-item'}>Delete
                            </div>
                        </div>}
                    </div>}
                </div>
            </div>
            <div className="singleOffer__deliverables-task-info">
                <div className="task-tab-list__photo singleOffer__deliverables-task-photos" style={{width: '20%'}}>
                    <div style={{display: "flex"}}>
                        {task.providers && task.providers.map((item: any) =>
                                                            <img
                                                                onClick={() => {
                                                                    userData && setModalData({id: item.id, type: item.type})
                                                                    userData && setModalType('manager_profile_modal')
                                                                }}
                                                                style={{
                                                                    marginLeft: '2px',
                                                                    width: '27px',
                                                                    height: '27px',
                                                                    borderRadius: '10px',
                                                                    cursor: 'pointer'
                                                                }}
                                                                src={item.avatar_path || clientIcon}
                                                                alt=""
                                                            />)}
                    </div>
                </div>
                <div className="singleOffer__deliverables-task-status" style={{width: '20%'}}>
                    <div className="singleOffer__deliverables-task-label">Status</div>
                    <div className={'singleOffer__deliverables-task-text  offer-task-status'} style={{color: getStatusItem(task.status)?.color}}>{getStatusItem(task.status)?.label}</div>
                </div>
                <div className="singleOffer__deliverables-task-status" style={{width: '18%'}}>
                    <div className="singleOffer__deliverables-task-label offer-task-estimate">Estimate</div>
                    <div
                        className={'singleOffer__deliverables-task-text offer-task-estimate'}>{task.type === 'COVERED_BY_SUBSCRIPTION' ? '-' : getTime(task.price_per_hour, task.accepted, task.deadline, task.time_estimate)}</div>
                </div>
                <div className="singleOffer__deliverables-task-status" style={{width: '22%'}}>
                    <div className="singleOffer__deliverables-task-label">Price</div>
                    {
                        task.type === 'COVERED_BY_SUBSCRIPTION' ?
                            <div className={'singleOffer__deliverables-task-text offer-task-price'} style={{color: '#F76800'}}>Covered by
                                Monthly Plan</div> :
                            <>
                                {task.credit_price === 0 && <div className={'singleOffer__deliverables-task-text offer-task-price'}>{(task.price_per_hour || task.credits_per_hour) ? `${task.price_per_hour ? `$${task.price_per_hour}/hour` : `${task.credits_per_hour} credit${+task.credits_per_hour > 1 ? 's' : ''}/hour`}` : `$${task.price_estimate}`}</div>}
                                {task.credit_price > 0 && <div className={'singleOffer__deliverables-task-text offer-task-price'}>{task.credit_price} Credit{+task.credit_price > 1 && "s"}</div>}
                            </>

                    }
                </div>
                {task.type === "PAID_BY_CREDIT" && <div className={'task-tab-list__paid-item'}>
                    Paid
                </div>}
                {(task.type !== "PAID_BY_CREDIT" && +task.client_intent_confirmed === 1 && userData?.status.type_code === 300) &&
                    <div style={{ width: "inherit", paddingLeft: "5px", paddingRight: "5px" }} className={'task-tab-list__paid-item'}>
                        Confirmed
                    </div>
                }
            </div>
        </div>
    )
}